// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"703ab407","329":"90613634"}[chunkId] + ".chunk.js";
};